import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";


export interface MasterFluxCookiePolicyPopupStyles {
    acceptGridItem?: GridItemProps;
    acceptButton?: ButtonPresentationProps;
    closeGridItem?: GridItemProps;
    closeButton?: ButtonPresentationProps;
    innerPolicyContainer?: InjectableCss;
    titleText?: TypographyPresentationProps;
}

export const masterFluxCookiePolicyPopupStyles: MasterFluxCookiePolicyPopupStyles = {
    innerPolicyContainer: {
        css: css`
            height: auto;
            max-height: calc(100% - 90px);
            margin: 45px;
            max-width: 800px;
            width: 100%;
            flex: 0 1 auto;
            display: flex;
            position: relative;
            flex-direction: column;
        `
    },
    acceptGridItem: {
        width: 12,
        css: css`
           margin: 30px auto  auto auto !important;
        `,
    },
    acceptButton: {
        css: css`
            width: 100%;
            background-color: #FFFFFF;
            border: none;
            color: #5F5AA3;
            border: 1px solid #5F5AA3;
            margin: 15px 38px;
            min-width: 350px;
            span {
                color: unset;
            }
            &:hover {
                background-color: #5F5AA3 !important;
                border: 1px solid #FFFFFF;
                color: #FFFFFF !important;
            }
        `,
    },
    closeGridItem: {
        width: 4,
        css: css`
           margin: 0 auto !important;
        `,
    },
    closeButton: {
        css: css`
            width: 100%;
            background-color: #949494;
            border: none;
            color: #FFFFFF;
            margin: 15px 38px;
            span {
                color: unset;
            }
            min-width: 350px;
            &:hover {
                background-color: #FFFFFF !important;
                border: 1px solid #949494;
                color: #949494 !important;
            }
        `,
    },
    titleText: {
        css: css`
            font-weight: bold;
            font-size: 28px;
            color: #949494;
            margin-bottom: 30px;
        `
    }
};

const styles = masterFluxCookiePolicyPopupStyles;

const MasterFluxCookiePolicyPopup = ({ id }: PageProps) => {
    const acceptHandler = () => {
        setCookie("acceptCookies", "true", { expires: 365 });
        setCookie("cookieconsent_status", "allow", { expires: 365 });
        // eslint-disable-next-line no-self-assign
        window.location.href = window.location.href;
    };

    const closeHandler = () => {
        setCookie("acceptCookies", "false", { expires: 365 });
        setCookie("cookieconsent_status", "deny", { expires: 365 });
        // eslint-disable-next-line no-self-assign
        window.location.href = window.location.href;
    };

    return (
        <StyledWrapper {...styles.innerPolicyContainer}>
            <Typography as="h2" data-test-selector="cookiePolicy_PrivacyPolicy" {...styles.titleText}>
                {siteMessage("Manage_Cookies")}
            </Typography>
            <Zone contentId={id} zoneName="cookiePolicy_PrivacyPolicy" />
            <GridItem {...styles.acceptGridItem}>
                <Button
                    {...styles.acceptButton}
                    onClick={acceptHandler}
                    data-test-selector="cookiePolicy_AcceptCookies"
                    disabled={!!((getCookie("cookieconsent_status") && getCookie("cookieconsent_status") === "allow"))}
                >
                    {siteMessage("Accept_All_Cookies")}
                </Button>
                <Button
                    {...styles.closeButton}
                    onClick={closeHandler}
                    aria-label={translate("Close")}
                    data-test-selector="cookiePolicy_ClosePolicy"
                    disabled={!!((getCookie("cookieconsent_status") && getCookie("cookieconsent_status") === "deny"))}
                >
                    {siteMessage("Essential_Cookies_Only")}
                </Button>
            </GridItem>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MasterFluxCookiePolicyPopup,
    definition: {
        group: "Basic",
        displayName: "Masterflux Cookies Widget",
    },
};

export default widgetModule;
